import {html, LitElement} from "lit";
import {customElement} from "lit/decorators.js";
import {dropdownStyles} from "./Dropdown.styles.js";
import {dropdownSubmenuStyles} from "./DropdownSubmenu.styles.js";

import "./IconButton.js";

@customElement("pn-dropdown-submenu")
export class DropdownSubmenu extends LitElement {
	static styles = [dropdownStyles, dropdownSubmenuStyles];

	connectedCallback() {
		super.connectedCallback();
		this.setAttribute("role", "menu");
	}

	render() {
		return html`
			<div
				class="submenu-wrapper"
			>
				<div class="dropdown-menu custom-scroll-bar-light">
					<slot></slot>
				</div>
			</div>
		`;
	}
};

declare global {
	interface HTMLElementTagNameMap {
		"pn-dropdown-submenu": DropdownSubmenu;
	}
}
